import type { ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md';
  icon?: ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export function Button({
  children,
  variant = 'secondary',
  size = 'md',
  icon,
  onClick,
  className = '',
  type = 'button',
}: ButtonProps) {
  const variantClasses = {
    primary: 'bg-tide text-paper-hi hover:bg-tide-d font-medium glow-tide',
    secondary: 'bg-paper-hi text-ink-2 border hair hover:bg-paper-2',
    ghost: 'text-ink-3 hover:bg-paper-2',
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-[12px]',
    md: 'px-3.5 py-2 text-[13px]',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${variantClasses[variant]} ${sizeClasses[size]} rounded-md flex items-center gap-1.5 transition-colors ${className}`}
    >
      {icon}
      {children}
    </button>
  );
}
